import { ref, onMounted, watch } from "vue";

// 从线上 CDN JSON 随机抽取 N 个真实 AI 效果，且每次路由切换重新随机。
// 仅客户端运行：SSR 时返回空数组，onMounted 后填充。

function normalizePool(data) {
  if (data == null) return [];
  if (Array.isArray(data)) return data;
  if (typeof data === "object") {
    return Object.values(data).flat();
  }
  return [];
}

function buildPool(rawVideo, rawImage, cdnBase) {
  const list = [...normalizePool(rawVideo), ...normalizePool(rawImage)];
  return list
    .filter((e) => e && e.code && e.title && e.cover_url && e.cover_gif)
    .map((e) => {
      const type = e.effect_type === "image" ? "image" : "video";
      return {
        title: e.title,
        code: e.code,
        type,
        thumb: /^https?:\/\//.test(e.cover_url) ? e.cover_url : (cdnBase || "") + e.cover_url,
        gif: e.cover_gif
          ? (/^https?:\/\//.test(e.cover_gif) ? e.cover_gif : (cdnBase || "") + e.cover_gif)
          : "",
        href: `/ai/effects/${type}/${e.code}/`,
      };
    });
}

function shuffleTake(pool, count) {
  const arr = [...pool];
  for (let i = arr.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr.slice(0, count);
}

export function useRandomEffects(count = 4) {
  const effects = ref([]);

  if (import.meta.client) {
    const r2 = useR2CachedFetch();
    const route = useRoute();
    const cdnBase = String(useRuntimeConfig().public.cdnUrl || "").replace(/\/$/, "");
    let pool = [];

    function pick() {
      if (!pool.length) return;
      effects.value = shuffleTake(pool, count);
    }

    onMounted(async () => {
      try {
        const [videoRaw, imageRaw] = await Promise.all([
          r2("/api/r2/ai/effects/video/index.json"),
          r2("/api/r2/ai/effects/image/index.json"),
        ]);
        pool = buildPool(videoRaw, imageRaw, cdnBase);
        pick();
      } catch {
        // 网络/解析失败时保持空数组，组件不渲染卡片。
      }
    });

    watch(() => route.fullPath, pick);
  }

  return effects;
}
